import { getGameId, getHrefParam } from "../store/ultile";
export const ACCOUNT_LOGIN = "login";
export const ACCOUNT_REGIST = "regist";
export const SWITCH_ACCOUNT = 1;
export const LOGIN_ACCOUNT = 0;

export const MESSAG_REGIST = "messageRegist";
export const MESSAG_LOGIN = "messageLogin";
export const MESSAG_SWITCH = "messageSwitch";
export const LOGIN_SUCCESS = "logonSuccess";
export const REGIST_SUCCESS = "registSuccess";
export const POP_HITORY = "popHistory";
export const SWITCH_URL = "switchUrl";
export const LOAD_USER_INFO = "loadUserInfo";
// export const MOBILE_LOGIN_PAGE_URL = "//m.gm99.com/h5Game/h5_game_page/mobile";
// export const MOBILE_GAME_PAGE_URL = "//m.gm99.com/h5Game/h5_game_page/gamepage";
var anylyzeParam =
  "&cid=" +
  (getHrefParam("cid") || "") +
  "&scid=" +
  (getHrefParam("scid") || "") +
  "&ad_id=" +
  (getHrefParam("ad_id") || "") +
  "&link_id" +
  (getHrefParam("link_id") || "") +
  "&uri=" +
  (getHrefParam("uri") || "") +
  "&channel=" +
  (getHrefParam("channel") || "") +
  "&sub_channel=" +
  (getHrefParam("sub_channel") || "") +
  "&sub_id=" +
  (getHrefParam("sub_id") || "") +
  "&subid=" +
  (getHrefParam("subid") || "") +
  "&pid=" +
  (getHrefParam("pid") || "") +
  "&app_id=" +
  (getHrefParam("app_id") || "") +
  "&fb_source=" +
  (getHrefParam("fb_source") || "") +
  "&auth_uid=" +
  (getHrefParam("auth_uid") || "") +
  "&register=" +
  (getHrefParam("register") || "") +
  "&forward=" +
  (getHrefParam("forward") || "");

export const GAME_ID = getGameId();
export const MOBILE_LOGIN_PAGE_URL =
  (process.env.NODE_ENV !== "production"
    ? "http://mlocal.gm99.com/html/mobile.html"
    : "//m.gm99.com/h5/page/mobile") +
  "?game_id=" +
  GAME_ID +
  anylyzeParam;
export const MOBILE_GAME_PAGE_URL =
  (process.env.NODE_ENV !== "production"
    ? "http://mlocal.gm99.com/html/gamePage.html"
    : "//m.gm99.com/h5/page/gamepage") +
  "?game_id=" +
  GAME_ID +
  anylyzeParam;
export const desktopUrl = "//m.gm99.com/desktop.php";



// WEBPACK FOOTER //
// ./src/utile/constRegist.js